import * as React from "react";
const GeldTerug = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14.857a6.92 6.92 0 0 1-5.786-3.107c-.107-.179-.285-.321-.5-.321-.464 0-.75.464-.5.857A8 8 0 0 0 8 16c4.393 0 8-3.571 8-8 0-4.393-3.607-8-8-8a7.94 7.94 0 0 0-5.25 1.964L1.643.857A.98.98 0 0 0 .964.571c-.535 0-.964.465-.964 1v3.572c0 .321.25.571.571.571h3.572c.536 0 1-.428 1-.964 0-.25-.107-.5-.286-.679L3.571 2.786A6.82 6.82 0 0 1 8 1.143 6.86 6.86 0 0 1 14.857 8 6.86 6.86 0 0 1 8 14.857M1.143 4.571V1.964L3.75 4.571zM5.53 7.863h.229v.457H5.53a.46.46 0 0 0-.457.457c0 .257.2.457.457.457h.4a3.08 3.08 0 0 0 2.915 2.057h.343a.46.46 0 0 0 .457-.457.47.47 0 0 0-.457-.457h-.343A2.15 2.15 0 0 1 6.93 9.234h1.8a.46.46 0 0 0 .458-.457.47.47 0 0 0-.458-.457H6.674v-.457h2.057a.46.46 0 0 0 .458-.457.47.47 0 0 0-.458-.457h-1.8a2.18 2.18 0 0 1 1.915-1.143h.343a.46.46 0 0 0 .457-.457.47.47 0 0 0-.457-.458h-.343c-1.343 0-2.5.872-2.915 2.058h-.4a.46.46 0 0 0-.457.457c0 .257.2.457.457.457"
      fill="#000"
    />
  </svg>
);
export default GeldTerug;
